import React from 'react';
import ReactSelectize from 'react-selectize';
import MaxLengthCounter from './MaxLengthCounter';
import isEqual from 'lodash/isEqual';
import './SelectField.styl';

/**
 * @deprecated Please, use `@components/auto-complete` instead
 *
 * Simplest usage is:
 *
 * import React, {useState} from 'react';
 * import AutoComplete from '@components/auto-complete';
 *
 * const options = [
 *   {title: 'First Title', value: '1'},
 *   {title: 'Second Title', value: '2'},
 * ];
 *
 * const MyComponent = () => {
 *   const [value, setValue] = useState();
 *
 *   return (
 *     <AutoComplete
 *        options={options}
 *        value={value}
 *        onChange={setValue}
 *     />
 *   );
 * }
 */
class SelectField extends React.PureComponent {
  handleChange = selectedValue => {
    const value = selectedValue ? selectedValue.value : null;
    this.props.onChange(value);
    if (this.props.updateSearch) {
      this.props.updateSearch('');
    }
  };

  getOptionByValue(options, value) {
    if (!options) {
      return;
    }

    if (value && value.equals) {
      // Use immutable equality checks instead
      return options.find(option => value.equals(option.value));
    }

    return options.find(option => isEqual(option.value, value));
  }

  onSearchChange = search => {
    if (this.props.maxLength && search.length > this.props.maxLength) {
      return;
    }
    this.props.onSearchChange && this.props.onSearchChange(search);
  };

  onOpenChange = open => {
    this.props.onOpenChange && this.props.onOpenChange(open);
  };

  render() {
    const {
      // eslint-disable-next-line
      onChange,
      onBlur,
      // eslint-disable-next-line
      onError,
      options,
      value,
      maxLength,
      renderOption,
      hideResetButton = false,
      ...extraProps
    } = this.props;

    const {search} = this.props;

    const option = this.getOptionByValue(options, value);
    const preparedOptions = options && !!options.toArray ? options.toArray() : options;
    return (
      <div
        className="ev-select-field ev-input"
        onMouseEnter={this.props.onMouseEnter}
        onMouseLeave={this.props.onMouseLeave}>
        <ReactSelectize.SimpleSelect
          {...extraProps}
          onValueChange={this.handleChange}
          onBlur={onBlur}
          onOpenChange={this.onOpenChange}
          options={preparedOptions}
          renderOption={renderOption}
          tetherProps={{ref: ref => (this.dropdownWrapper = ref)}}
          value={option}
          onSearchChange={this.onSearchChange}
          hideResetButton={hideResetButton}
        />
        <MaxLengthCounter maxLength={maxLength} value={search} />
      </div>
    );
  }
}

export default SelectField;
